import Container from "./Container";
import Section from "./Section";
import SectionWithContainer from "./SectionWithContainer";
import SectionTitleSubTitle from "./SectionTitleSubTitle";
import TwoColSection from "@/components/sectionComponents/TwoColSection";
import TwoColSection2 from "./TwoColSection2";
export {
  Container,
  Section,
  SectionWithContainer,
  SectionTitleSubTitle,
  TwoColSection,
  TwoColSection2,
};
